import { configureStore } from '@reduxjs/toolkit';

import { AuthAPI } from './services/rtk/AuthAPI';
import { SettingsAPI } from './services/rtk/SettingsAPI';

export const Store = configureStore({
    reducer: {
        [AuthAPI.reducerPath]: AuthAPI.reducer,
        [SettingsAPI.reducerPath]: SettingsAPI.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(AuthAPI.middleware).concat(SettingsAPI.middleware)
});
